module.exports = __webpack_public_path__ + "static/alexis-a99a1445232f3e672a637c263cab3415.png";